import { useParams } from "react-router";
import { useOutletContext } from "react-router-dom";

import PatientEdiaryPanel from "./PatientEdiaryPanel";

const PatientEdiary = () => {
  const { _id_ } = useParams();

  const { trialFilter, setActive, setBreadcrumbTitle, isTrialLocked } = useOutletContext();

  setActive("ediary");
  setBreadcrumbTitle("eDiary");

  return (
    <PatientEdiaryPanel
      patientId={_id_}
      trialId={trialFilter}
      isTrialLocked={isTrialLocked}
      showSchedule={false}
    />
  );
};

export default PatientEdiary;
